import { render, staticRenderFns } from "./CreateParcel.vue?vue&type=template&id=cfeb7fd6&"
import script from "./CreateParcel.vue?vue&type=script&lang=js&"
export * from "./CreateParcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports